import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './locales/en/common.json';
import enIdentification from './locales/en/identification.json';
import enIdentifyPlayers from './locales/en/identifyPlayers.json';
import enReport from './locales/en/report.json';
import enBallmap from './locales/en/ballmap.json';
import enElite from './locales/en/elite.json';
import enTournament from './locales/en/tournament.json';

import ptCommon from './locales/pt/common.json';
import ptIdentification from './locales/pt/identification.json';
import ptIdentifyPlayers from './locales/pt/identifyPlayers.json';
import ptReport from './locales/pt/report.json';
import ptBallmap from './locales/pt/ballmap.json';
import ptElite from './locales/pt/elite.json';
import ptTournament from './locales/pt/tournament.json';

const lang = new URLSearchParams(window.location.search).get('lang') ?? 'pt';

i18n.use(initReactI18next).init({
  // Pin the JSON plural format we author against (CLDR v4: `_one`, `_other`).
  // Without this, an i18next major bump could silently change resolution.
  compatibilityJSON: 'v4',
  resources: {
    en: {
      common: enCommon,
      identification: enIdentification,
      identifyPlayers: enIdentifyPlayers,
      report: enReport,
      ballmap: enBallmap,
      elite: enElite,
      tournament: enTournament,
    },
    pt: {
      common: ptCommon,
      identification: ptIdentification,
      identifyPlayers: ptIdentifyPlayers,
      report: ptReport,
      ballmap: ptBallmap,
      elite: ptElite,
      tournament: ptTournament,
    },
  },
  lng: lang,
  fallbackLng: 'pt',
  ns: [
    'common',
    'identification',
    'identifyPlayers',
    'report',
    'ballmap',
    'elite',
    'tournament',
  ],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
